/**
 * Dashboard Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('./views/DashboardView.vue'),
    meta: {
      title: () => i18next.t('dashboard.overviewTitle'),
      breadcrumbs: [
        { label: () => i18next.t('dashboard.overviewTitle') },
      ],
    },
  },
];
